/**
 * Manually curated Instagram post/reel embeds shown on the site.
 *
 * HOW TO ADD OR CHANGE A POST:
 *  1. Open the post on instagram.com (or the Instagram app) and copy its share link,
 *     e.g. https://www.instagram.com/p/AbCdEfGhIjK/
 *  2. Add it to this array (keep it to 3-6 posts so the section stays fast).
 *  3. Deploy. No API keys or scraping involved — this uses Instagram's official
 *     public oEmbed-style <blockquote> embed, loaded lazily so it never blocks the
 *     check-in form (see components/InstagramPanel.tsx).
 *
 * If this array is empty, the site still shows a prominent link to
 * @nine80_hairstudio instead of an empty section.
 */
export const INSTAGRAM_POST_URLS: string[] = [
  // 'https://www.instagram.com/p/REPLACE_ME/',
];

export const INSTAGRAM_PROFILE_URL = 'https://www.instagram.com/nine80_hairstudio/';
export const INSTAGRAM_HANDLE = '@nine80_hairstudio';
